import { FunctionComponent, ReactNode } from 'react'
import styled from 'styled-components'

const StyledTopBottomHeader = styled.div`
  background-color: rgba(0, 0, 0, 0.6);
  width: 100%;
`

const TopBottomHeader: FunctionComponent<{ children?: ReactNode }> = ({
  children,
}) => {
  return <StyledTopBottomHeader>{children}</StyledTopBottomHeader>
}

export default TopBottomHeader
